/**
 * Central data-testid registry for TySoce (kebab-case, role-based).
 */
export const TESTIDS = {
    // Auth
    loginEmail: 'login-email-input',
    loginPassword: 'login-password-input',
    loginSubmit: 'login-submit-button',
    logoutButton: 'logout-button',

    // Top bar
    scopeSwitcherBrand: 'scope-switcher-brand-select',
    scopeSwitcherAccount: 'scope-switcher-account-select',
    emergencyStopButton: 'emergency-stop-button',
    emergencyStopConfirm: 'emergency-stop-confirm-button',
    emergencyStopCancel: 'emergency-stop-cancel-button',

    // Sidebar
    sidebarDashboard: 'sidebar-nav-dashboard',
    sidebarBrands: 'sidebar-nav-brands',
    sidebarAccounts: 'sidebar-nav-accounts',
    sidebarComposer: 'sidebar-nav-composer',
    sidebarDrafts: 'sidebar-nav-drafts',
    sidebarCalendar: 'sidebar-nav-calendar',
    sidebarComments: 'sidebar-nav-comments',
    sidebarInbox: 'sidebar-nav-inbox',
    sidebarAnalytics: 'sidebar-nav-analytics',
    sidebarAutomation: 'sidebar-nav-automation',
    sidebarAuditLogs: 'sidebar-nav-audit-logs',
    sidebarSettings: 'sidebar-nav-settings',

    // Dashboard
    dashboardKpiCard: 'dashboard-kpi-card',

    // Brands
    brandsCreateButton: 'brands-create-button',
    brandsCreateNameInput: 'brands-create-name-input',
    brandsCreateDescriptionInput: 'brands-create-description-input',
    brandsCreateSubmit: 'brands-create-submit-button',
    brandCard: 'brand-card',
    brandEditName: 'brand-edit-name-input',
    brandSaveButton: 'brand-save-button',
    brandAddVoiceSampleInput: 'brand-add-voice-sample-input',
    brandAddVoiceSampleButton: 'brand-add-voice-sample-button',
    brandAddBannedWordInput: 'brand-add-banned-word-input',
    brandAddBannedWordButton: 'brand-add-banned-word-button',

    // Accounts
    accountsConnectButton: 'accounts-connect-button',
    accountsConnectBrandSelect: 'accounts-connect-brand-select',
    accountsConnectHandleInput: 'accounts-connect-handle-input',
    accountsConnectSubmit: 'accounts-connect-submit-button',
    accountRow: 'account-row',
    accountEmergencyStopToggle: 'account-emergency-stop-toggle',

    // Composer
    composerBrandSelect: 'composer-brand-select',
    composerAccountChip: 'composer-account-chip',
    composerPlatformSelect: 'composer-platform-select',
    composerContentTypeSelect: 'composer-content-type-select',
    composerTopicInput: 'composer-topic-input',
    composerGoalInput: 'composer-goal-input',
    composerToneInput: 'composer-tone-input',
    composerCtaInput: 'composer-cta-input',
    composerMentionInput: 'composer-mention-input',
    composerLocationInput: 'composer-location-input',
    composerGenerateButton: 'composer-generate-button',
    composerVariantCard: 'composer-variant-card',
    composerVariantUseButton: 'composer-variant-use-button',
    composerEditCaption: 'composer-edit-caption-textarea',
    composerSaveDraft: 'composer-save-draft-button',
    composerSchedule: 'composer-schedule-button',
    composerScheduleDateInput: 'composer-schedule-date-input',
    composerScheduleConfirm: 'composer-schedule-confirm-button',
    composerPublishNow: 'composer-publish-now-button',
    composerPublishConfirmDialog: 'publish-multi-account-confirm-dialog',
    composerPublishConfirm: 'publish-multi-account-confirm-button',

    // Drafts
    draftRow: 'draft-row',

    // Calendar
    calendarEventTile: 'calendar-event-tile',
    calendarPrev: 'calendar-prev-button',
    calendarNext: 'calendar-next-button',

    // Inbox - comments
    commentRow: 'inbox-conversation-row',
    commentClassifyButton: 'comment-classify-button',
    commentDraftReplyButton: 'comment-draft-reply-button',
    commentReplySend: 'comment-reply-send-button',
    commentReplyEdit: 'comment-reply-edit-textarea',
    inboxFilterClassification: 'inbox-filter-classification-select',

    // Inbox - DMs
    dmThreadRow: 'dm-thread-row',
    dmDraftReplyButton: 'dm-draft-reply-button',
    dmReplyEdit: 'dm-reply-edit-textarea',
    dmReplySendButton: 'dm-reply-send-button',

    // Automation
    automationGlobalToggle: 'automation-global-emergency-toggle',
    automationAccountRow: 'automation-account-row',
    automationToggleManualApproval: 'automation-toggle-manual-approval',
    automationToggleAutoReply: 'automation-toggle-auto-reply',
    automationToggleAccountStop: 'automation-toggle-account-stop',

    // Audit
    auditSearchInput: 'audit-log-search-input',
    auditRow: 'audit-log-row',
};

export default TESTIDS;
